import Vue from 'vue'
import Router from 'vue-router'
import App from '@/App'
import Login from '@/views/Login'
import Home from '@/views/Home'


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: App,
      children: [
        {
          path: '/operation/login',
          component: Login
        },
        {
          path: '/operation/home',
          component: Home
        },
        // {
        //   path: '/*',
        //   component: Home
        // }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js